import { useMemo } from 'react';
import useRequest from '@gp/hooks/useRequest';
import { getScheduleMonthlyList } from '@gp/services/overview';
import { filterCalendarHasTimeChange } from '../utils';

import type { ICalendarTableItemDetails, ICalendarTableDTO } from '@gp/types/calendar';

// 月历数据逻辑
export default function useCalendarMonthly(timeChange: boolean, category: string) {
  const {
    loading: calendarMonthlyDataLoading,
    data: calendarMonthlyData,
    run: getScheduleMonthlyDataRun,
    runAsync: getScheduleMonthlyDataRunAsync,
    cancel: getScheduleMonthlyDataCancel,
  } = useRequest(getScheduleMonthlyList, {
    manual: true,
  });

  const calendarMonthlyList = useMemo<ICalendarTableDTO[]>(
    () => calendarMonthlyData?.list || [],
    [calendarMonthlyData],
  );

  // 增加图例过滤逻辑后的月历数据
  const calendarMonthlyListFiltered = useMemo<ICalendarTableDTO[]>(() => {
    if (!Array.isArray(calendarMonthlyList) || !calendarMonthlyList.length) return [];

    const calendarMonthlyListTmp: ICalendarTableDTO[] = [];

    for (const calendarMonthlyItem of calendarMonthlyList) {
      const { details } = calendarMonthlyItem || {};
      const detailsTmp: ICalendarTableItemDetails[] = [];
      let hasMilestone = false;

      if (!Array.isArray(details) || !details.length) continue;

      for (const detail of details) {
        const { milestones } = detail || {};
        // 过滤category
        let milestonesValueList = milestones;
        if (category?.length) {
          const tempList = milestones || [];
          const tempListValue = [...tempList];
          milestonesValueList = tempListValue?.filter((item: any) =>
            category?.includes(item.category),
          );
        }
        const milestonesTmp = !timeChange
          ? milestonesValueList
          : filterCalendarHasTimeChange(milestonesValueList);
        if (Array.isArray(milestonesTmp) && milestonesTmp.length > 0) {
          hasMilestone = true;
        }
        detailsTmp.push({ ...detail, milestones: milestonesTmp || [] });
      }

      if (hasMilestone) {
        calendarMonthlyListTmp.push({ ...calendarMonthlyItem, details: detailsTmp });
      }
    }

    return calendarMonthlyListTmp;
  }, [timeChange, calendarMonthlyList, category]);

  // 是否无月粒度数据
  const calendarMonthlyDataNoData = useMemo<boolean>(() => {
    if (calendarMonthlyDataLoading) return false;
    return !Array.isArray(calendarMonthlyListFiltered) || !calendarMonthlyListFiltered.length;
  }, [calendarMonthlyDataLoading, calendarMonthlyListFiltered]);

  return {
    calendarMonthlyDataLoading,
    calendarMonthlyDataNoData,
    calendarMonthlyListFiltered,
    getScheduleMonthlyDataRun,
    getScheduleMonthlyDataRunAsync,
    getScheduleMonthlyDataCancel,
  };
}
